// extracted by mini-css-extract-plugin
export default {"logo":"qH7ug8","return":"Vd3pI_","hideLogo":"cXKvPa"};